export default __webpack_public_path__ + "static/media/icon_x.c753ae49.svg";